import {
  HOME_PUBLISH_ASSIGNMENTS_BEGIN,
  HOME_PUBLISH_ASSIGNMENTS_SUCCESS,
  HOME_PUBLISH_ASSIGNMENTS_FAILURE,
  HOME_PUBLISH_ASSIGNMENTS_DISMISS_ERROR,
} from './constants';

import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function publishAssignments(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_PUBLISH_ASSIGNMENTS_BEGIN,
    });

    console.log({publishArgs: args});

    
    const promise = new Promise((resolve, reject) => {
      axios.post("/api/values/publish",args)

    .then(
      (res) => {
        console.log({res});
        dispatch({
          type: HOME_PUBLISH_ASSIGNMENTS_SUCCESS,
          data: res.data,
        });
        resolve(res);
      },
      // Use rejectHandler as the second argument so that render errors won't be caught.
      (err) => {
        dispatch({
          type: HOME_PUBLISH_ASSIGNMENTS_FAILURE,
          data: { error: err },
        });
        reject(err);
      },
    );
    });
  

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissPublishAssignmentsError() {
  return {
    type: HOME_PUBLISH_ASSIGNMENTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_PUBLISH_ASSIGNMENTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        publishAssignmentsPending: true,
        publishAssignmentsError: null,
      };

    case HOME_PUBLISH_ASSIGNMENTS_SUCCESS:
      // The request is success
      return {
        ...state,
        schedules: 
        {
          ...state.schedules,
          [action.data.schedule.id]: action.data.schedule
        },
        publishAssignmentsPending: false,
        publishAssignmentsError: action.data.errors,
      };

    case HOME_PUBLISH_ASSIGNMENTS_FAILURE:
      // The request is failed
      return {
        ...state,
        publishAssignmentsPending: false,
        publishAssignmentsError: action.data.error,
      };

    case HOME_PUBLISH_ASSIGNMENTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        publishAssignmentsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/publishAssignments.js